import { IsBoolean, IsNotEmpty } from 'class-validator';

export class CidadeAlterarAtivoDto {
  @IsBoolean()
  @IsNotEmpty()
  ativo: boolean;
}
